import { render, staticRenderFns } from "./WorkFormView.vue?vue&type=template&id=a6733424"
import script from "./WorkFormView.vue?vue&type=script&lang=js"
export * from "./WorkFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports